import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const MENUS = {
  candidato: [
    { icon:'🏠', label:'Início',          path:'/candidato' },
    { icon:'👤', label:'Meu Perfil',      path:'/candidato/perfil' },
    { icon:'🎯', label:'Vagas p/ Mim',    path:'/candidato/matches' },
    { icon:'💚', label:'Match',           path:'/match' },
    { icon:'💬', label:'Mensagens',       path:'/chat' },
    { icon:'📋', label:'Ver Vagas',       path:'/vagas' },
    { icon:'⭐', label:'Destaque',       path:'/candidato/destaque' },
  ],
  empresa: [
    { icon:'📊', label:'Dashboard',        path:'/empresa' },
    { icon:'📋', label:'Minhas Vagas',     path:'/empresa/vagas' },
    { icon:'➕', label:'Nova Vaga',        path:'/empresa/vagas/nova' },
    { icon:'💚', label:'Match Candidatos', path:'/match' },
    { icon:'🎯', label:'Em Seleção',       path:'/empresa/selecao' },
    { icon:'💬', label:'Mensagens',        path:'/chat' },
    { icon:'🏢', label:'Perfil da Empresa',path:'/empresa/perfil' },
    { icon:'💳', label:'Plano & PIX',      path:'/empresa/pagamento' },
  ],
  admin: [
    { icon:'📊', label:'Dashboard',          path:'/admin' },
    { icon:'💰', label:'Pagamentos',         path:'/admin/pagamentos' },
    { icon:'📈', label:'Financeiro',         path:'/admin/financeiro' },
    { icon:'👥', label:'Usuários',           path:'/admin/usuarios' },
    { icon:'🏢', label:'Empresas',           path:'/admin/empresas' },
    { icon:'👤', label:'Candidatos',         path:'/admin/candidatos' },
    { icon:'💳', label:'Cobranças',          path:'/admin/cobrancas' },
    { icon:'👁️', label:'Ver Candidato',      path:'/admin/preview/candidato' },
    { icon:'🏛️', label:'Ver Empresa',        path:'/admin/preview/empresa' },
    { icon:'⚙️', label:'Configurações',      path:'/admin/configuracoes' },
    { icon:'📋', label:'Logs',               path:'/admin/logs' },
    { icon:'🔧', label:'Debug',              path:'/admin/debug' },
  ],
};

export default function Sidebar() {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [mob, setMob] = useState(false);
  const links = MENUS[user?.tipo] || [];
  // Ativo se: match exato OU começa com p+'/' MAS nenhum outro item tem match exato
  const active = p => {
    if (location.pathname === p) return true;
    // Nunca usar prefix match para rotas raiz de cada painel (evita /admin destacar em /admin/usuarios)
    const rotasExatas = ['/admin', '/empresa', '/candidato', '/vagas', '/match', '/chat'];
    if (rotasExatas.includes(p)) return false;
    // Para outras rotas: só ativa por prefixo se nenhum outro item do menu for match exato
    if (p.length > 1 && location.pathname.startsWith(p + '/')) {
      return !links.some(item => item.path !== p && item.path === location.pathname);
    }
    return false;
  };

  const Content = () => (
    <div className="flex flex-col h-full">
      <Link to="/" className="flex items-center gap-2.5 px-5 py-4 border-b border-white/10">
        <span className="text-2xl">🌿</span>
        <span className="font-sora font-bold text-xl text-white">Acre<span className="text-acre-gold">Job</span></span>
      </Link>

      <div className="px-4 py-3 border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <div className="relative">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-acre-green to-acre-teal flex items-center justify-center text-white font-bold text-sm">{user?.nome?.charAt(0).toUpperCase()}</div>
            <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-acre-dark"/>
          </div>
          <div className="min-w-0">
            <p className="text-white text-sm font-semibold truncate">{user?.nome?.split(' ')[0]}</p>
            <p className="text-white/40 text-xs capitalize">{user?.tipo}</p>
          </div>
        </div>
        {user?.tipo==='empresa' && (
          <div className="mt-1.5">
            {user?.status_pagamento==='ativo'
              ? <span className="text-xs text-green-400 font-medium flex items-center gap-1"><span className="w-1.5 h-1.5 bg-green-400 rounded-full"/>Acesso ativo</span>
              : <Link to="/empresa/pagamento" className="text-xs text-yellow-400 hover:text-yellow-300 transition-colors">⚠️ {user?.status_pagamento?.replace(/_/g,' ')}</Link>}
          </div>
        )}
        {user?.tipo==='candidato' && user?.selo_verificado && <p className="mt-1 text-xs text-acre-gold">⭐ Candidato Ouro</p>}
      </div>

      <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
        {links.map(({icon,label,path})=>(
          <Link key={path} to={path} onClick={()=>setMob(false)}
            className={`flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all
              ${active(path)?'bg-acre-green text-white shadow-sm':'text-white/55 hover:text-white hover:bg-white/8'}`}>
            <span className="text-base w-5 text-center flex-shrink-0">{icon}</span>
            {label}
          </Link>
        ))}
      </nav>

      <div className="p-3 border-t border-white/10">
        <button onClick={()=>{logout();navigate('/');}}
          className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm text-white/40 hover:text-red-300 hover:bg-white/5 transition-all">
          <span>🚪</span> Sair
        </button>
      </div>
    </div>
  );

  return (
    <>
      <aside className="hidden md:flex flex-col w-56 bg-acre-dark fixed left-0 top-0 bottom-0 z-40 overflow-hidden">
        <Content/>
      </aside>
      <div className="md:hidden bg-acre-dark px-4 h-12 flex items-center justify-between sticky top-0 z-40">
        <Link to="/" className="font-sora font-bold text-lg text-white">🌿 Acre<span className="text-acre-gold">Job</span></Link>
        <button onClick={()=>setMob(!mob)} className="text-white p-1">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mob?<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                :<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>}
          </svg>
        </button>
      </div>
      {mob && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-acre-dark h-full overflow-y-auto"><Content/></div>
          <div className="flex-1 bg-black/50" onClick={()=>setMob(false)}/>
        </div>
      )}
    </>
  );
}
